import { render, staticRenderFns } from "./CoinItemDialog.vue?vue&type=template&id=2e96f2ac&scoped=true&"
import script from "./CoinItemDialog.vue?vue&type=script&lang=js&"
export * from "./CoinItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoinItemDialog.vue?vue&type=style&index=0&id=2e96f2ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e96f2ac",
  null
  
)

export default component.exports